import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';

export default function TooltipLink({
  className,
  handleClose,
  title,
  description,
  linkText,
  linkHref,
  linkOnClick = null,
  ...props
}) {
  return (
    <Box
      className={`${styles.tooltipLink} ${className ?? ''}`}
      onClick={(event) => event.stopPropagation()}
      data-testid="tooltip-link"
      {...props}
    >
      <Box className={styles.tooltipLinkHeader}>
        <Text className={styles.tooltipLinkTitle}>{title}</Text>
        <Box
          as="button"
          onClick={handleClose}
          className={styles.tooltipLinkCloseButton}
          data-testid="tooltip-link-close"
        >
          <Icon icon="icon-cerrar" fontSize="12px" color="#FFFFFF" />
        </Box>
      </Box>

      <Text className={styles.tooltipLinkDescription}>{description}</Text>

      <Box
        as="a"
        className={styles.tooltipLinkAnchor}
        href={linkHref}
        target="_blank"
        onClick={() => linkOnClick && linkOnClick()}
      >
        <Text>{linkText}</Text>

        {linkHref && <Icon icon="icon-ir" fontSize="12px" color="#FFFFFF" />}
      </Box>
    </Box>
  );
}
